export default __webpack_public_path__ + "static/media/1.07fd4720.png";